import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  id: "colour-fill-icon",
  role: "img",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      d: "M12.7909 4.17122C12.3709 3.60955 11.5324 3.60959 11.1124 4.17134L6.79796 9.94196C3.62074 14.1935 6.65261 20.2502 11.9517 20.2502C17.2509 20.2502 20.2827 14.1936 17.1038 9.9421L12.7909 4.17122Z",
      fill: "var(--selected-colour, transparent)"
    }, null, -1),
    _createElementVNode("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M12.7905 4.17122C12.3704 3.60955 11.532 3.60959 11.112 4.17134L6.79751 9.94196C3.62029 14.1935 6.65216 20.2502 11.9513 20.2502C17.2505 20.2502 20.2823 14.1936 17.1034 9.9421L12.7905 4.17122ZM11.9513 21.7502C5.41377 21.7502 1.68142 14.282 5.59598 9.044L9.91062 3.27314C10.9306 1.90895 12.972 1.90895 13.9919 3.27314L18.3047 9.04385C22.2213 14.2819 18.4888 21.7502 11.9513 21.7502Z"
    }, null, -1)
  ])))
}
export default { render: render }